export const REDIRECT_START = 'REDIRECT_START';
export const REDIRECT_CLEAR = 'REDIRECT_CLEAR';
export const SET_HAS_PENDING_CHANGES = 'SET_HAS_PENDING_CHANGES';
export const EXPAND_COLLAPSE = 'EXPAND_COLLAPSE';
export const SET_LAST_URL_VISITED_IN_WS = 'SET_LAST_URL_VISITED_IN_WS';
